import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import { PO_HEADER } from '../model/PO_HEADER.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../model/api-response-model';

@Injectable({
  providedIn: 'root'
})
export class PoheaderService {

  constructor(private crudService: CrudService) { }

  SavePORecord(model: any): Observable<ApiResponseModel>{
    return this.crudService.post<any>('PurchaseInvoice/SavePurchaseInvoice', model);
  }
  
  GetAllMasters(): Observable<any>{
    return this.crudService.get<any>('PurchaseInvoice/GetAllMasters');
  }
 

  // GetAllPaymentInformation(): Observable<any>{
  //   return this.crudService.get<any>('PurchaseInvoice/GetAllPaymentInforamtion');
  // }

  GetAllPaymentInformation(InvoiceNo:string=''): Observable<any>{
    return this.crudService.get<any>('PurchaseInvoice/GetAllPaymentInforamtion?InvoiceNo='+InvoiceNo);
  }

  // GetAllPurchaseInvoice(): Observable<any>{
  //   return this.crudService.get<any>('PurchaseInvoice/GetAllPurchaseInvoice');
  // }

  GetAllPurchaseInvoice(userType:string, username:string , status:string ): Observable<any>{
    return this.crudService.get<any>(`PurchaseInvoice/GetAllPurchaseInvoice?userType=${userType}&username=${username}&status=${status}`);
  }

  GetPurchaseInvoiceSummary(userType:string, username:string): Observable<any>{
    return this.crudService.get<any>(`PurchaseInvoice/GetPurchaseInvoiceSummary?userType=${userType}&username=${username}`);
  }

  GetDashboardCreditMemoDetails(userType:string, username:string , status:string ): Observable<any>{
    return this.crudService.get<any>(`CreditMemo/GetDashboardCreditMemoDetails?userType=${userType}&username=${username}&status=${status}`);
  }

  GetDashboardCreditMemoSummary(userType:string, username:string): Observable<any>{
    return this.crudService.get<any>(`CreditMemo/GetDashboardCreditMemoSummary?userType=${userType}&username=${username}`);
  }


  GetAllCreditMemo(VendorNo:string,CrMemoNo:string): Observable<any>{
    return this.crudService.get<any>('CreditMemo/GetAllCreditMemoDetails?VendorNo='+VendorNo+'&CrMemoNo='+CrMemoNo);
  }

  DeletePurchaseInvoice(PurchaseInvoiceNo:any): Observable<any>{
    return this.crudService.get<any>('PurchaseInvoice/DeletePurchaseinvoice?PurchaseInvoiceNo='+PurchaseInvoiceNo);
  }
  DeleteCreditMemoDetails(CreditNoteNo:any): Observable<any>{
    return this.crudService.get<any>('CreditMemo/DeleteCreditMemoDetails?CreditNoteNo='+CreditNoteNo);
  }

  DeletePILine(PINo:any,LineNo:any): Observable<any>{
    return this.crudService.get<any>('PurchaseInvoice/DeletePILine?PINo='+PINo+'&LineNo='+LineNo);
  }
  GetPurchaseInvoiceByNo(PurchaseInvoioceNo:any): Observable<any>{
    return this.crudService.get<any>('PurchaseInvoice/GetPurchaseInvoiceById?PurchaseInvoiceNo='+PurchaseInvoioceNo);
  }

  GetByVendor(): Observable<ApiResponseModel>{
    return this.crudService.get<any>('PurchaseInvoice/GetPIByVendor');
  }
  GetBySeq(): Observable<ApiResponseModel>{
    return this.crudService.get<any>('PurchaseInvoice/GetPIBySeq/');
  }
  UpdatePORecord(model: PO_HEADER): Observable<ApiResponseModel>{
    return this.crudService.patch<any>('PurchaseInvoice/UpdatePIDetails', model);
  }
  DeactivatePORecord(model: PO_HEADER): Observable<ApiResponseModel>{
    return this.crudService.put<any>('PurchaseInvoice/DeactivatePIDetails', model);
  }
  UploadReferenceDoc(PurchaseInvoicNo:any, status:any,formdata: FormData): Observable<string> {
 
    return this.crudService.post('PurchaseInvoice/UploadDocuments?PurchaseInvoicNo=' + PurchaseInvoicNo+'&PH_Status='+status, formdata);
}
DeleteDocument(PurchaseInvoicNo:any, FileName:string): Observable<string> {
 
  return this.crudService.get('PurchaseInvoice/DeletePIDocument?PurchaseInvoicNo=' + PurchaseInvoicNo+'&FileName='+FileName);
}

DeleteCRDocument(CrNo:any, FileName:string,VendorNo:string): Observable<string> {
 
  return this.crudService.get('PurchaseInvoice/DeleteCrNoDocument?SalesCreditNo=' + CrNo+'&FileName='+FileName+'&VendorNo='+VendorNo);
}

 GetAllPIDocuments(PurchaseInvoicNo:any): Observable<any> {
 
    return this.crudService.get('PurchaseInvoice/GetAllPIDocuments?PurchaseInvoicNo=' + PurchaseInvoicNo);
}

GetAllCreditMemoDocuments(PostedInvoicNo:any,VendorNo:string): Observable<any> {
 
  return this.crudService.get('CreditMemo/GetAllCRDocuments?PostedInvoiceNo=' + PostedInvoicNo+"&VendorNo="+VendorNo);
}
SendEmail(EmailModel:any): Observable<any>{ 
  return this.crudService.post('PurchaseInvoice/SendEmail',EmailModel);
}

ResetPassword(UserName,Password,Newpassword): Observable<any>{ 
  return this.crudService.get('User/ResetPassword?UserName=' + UserName+"&Password="+Password+"&Newpassword="+Newpassword);
}

}
